export default __webpack_public_path__ + "static/media/sub-category-fitness-outdoorSportSpace.1da0c230.jpg";